module.exports = __webpack_public_path__ + "img/1557614082416254977.31a7adf3.png";